(() => {
  const MODAL_ID = 'SizeGuideModal';
  const TRIGGER_SELECTOR = '[data-size-guide-trigger], .js-size-guide-trigger';

  const formatInches = (value) => {
    return value.replace(/-?\d+(\.\d+)?/g, (match) => {
      const inches = Number(match) / 2.54;
      return `${Math.round(inches)}`;
    });
  };

  const updateUnit = (modal, unit) => {
    modal.dataset.unit = unit;

    modal.querySelectorAll('[data-size-guide-unit-button]').forEach((button) => {
      const isActive = button.dataset.sizeGuideUnitButton === unit;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    modal.querySelectorAll('[data-size-guide-measurement]').forEach((cell) => {
      const cmValue = cell.dataset.cmValue || '';
      cell.textContent = unit === 'inch' ? formatInches(cmValue) : cmValue;
    });
  };

  const activateTab = (modal, tabName) => {
    modal.querySelectorAll('[data-size-guide-tab-button]').forEach((button) => {
      const isActive = button.dataset.sizeGuideTabButton === tabName;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.tabIndex = isActive ? 0 : -1;
    });

    modal.querySelectorAll('[data-size-guide-panel]').forEach((panel) => {
      const isActive = panel.dataset.sizeGuidePanel === tabName;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });
  };

  const initModal = (modal) => {
    if (!modal || modal.dataset.sizeGuideInitialized === 'true') return;
    modal.dataset.sizeGuideInitialized = 'true';

    modal.querySelectorAll('[data-size-guide-tab-button]').forEach((button) => {
      button.addEventListener('click', () => activateTab(modal, button.dataset.sizeGuideTabButton));
    });

    modal.querySelectorAll('[data-size-guide-unit-button]').forEach((button) => {
      button.addEventListener('click', () => updateUnit(modal, button.dataset.sizeGuideUnitButton));
    });

    const activeTab = modal.querySelector('[data-size-guide-tab-button].is-active')?.dataset.sizeGuideTabButton || 'tops';
    activateTab(modal, activeTab);
    updateUnit(modal, 'cm');
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    const modal = document.getElementById(trigger.getAttribute('aria-controls') || MODAL_ID);
    if (!modal) return;

    event.preventDefault();
    initModal(modal);

    if (typeof modal.show === 'function') {
      modal.show(trigger);
    } else {
      modal.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    initModal(document.getElementById(MODAL_ID));
  });
})();